<template>
	<payHeader :bgStatus="bgStatus"></payHeader>
	<div class="user-repwd">
		<div class="container">
			<div class="head">
				<h1>找回密码</h1>
				<ul>
					<li class="step1 active">验证账号</li>
					<li class="step2 active">选择找回方式</li>
					<li class="step3">填写验证码</li>
					<li class="step4">重设密码</li>
				</ul>
			</div>
			<p class="tips">您正在为帐户 <el-text type="primary">{{repwdDatas.username}}</el-text> 找回密码，请选择身份验证方式：</p>
			<ul class="repwd-select" v-if="repwdDatas.checkemail == '1' || repwdDatas.checkmobile == '1' || repwdDatas.checkquention == '1'">
				<li v-if="repwdDatas.checkemail == '1'">
					<i class="email"></i>
					<h4>通过 "邮箱验证码"</h4>
					<p>如果您的邮箱 <el-text type="warning">{{repwdDatas.email_encrypt}}</el-text> 还在正常使用，请选择此方式</p>
					<router-link to="/repwdEmail" class="btn">立即验证</router-link>
				</li>
				<li v-if="repwdDatas.checkmobile == '1'">
					<i class="mobile"></i>
					<h4>通过 "短信验证码"</h4>
					<p>我们将以短信的形式把验证码发送到您的 <el-text type="warning">{{repwdDatas.mobile_encrypt}}</el-text> 手机</p>
					<router-link to="/repwdMobile" class="btn">立即验证</router-link>
				</li>
				<li v-if="repwdDatas.checkquention == '1'">
					<i class="pro"></i>
					<h4>通过 "密保问题"</h4>
					<p>通过正确回答您的 <el-text type="warning">{{repwdDatas.question}}</el-text> 密保问题</p>
					<router-link to="/repwdQuestion" class="btn">立即验证</router-link>
				</li>
			</ul>
			<el-result v-else icon="warning" title="请联系客服处理" />
		</div>
	</div>
	<payFooter></payFooter>
</template>

<script setup>
	import { ref,reactive,onMounted} from 'vue';
	import { useRouter } from 'vue-router';
	import { payHeader,payFooter } from 'landui-ui';
	
	const router = useRouter();
	const bgStatus = ref(true);
	const repwdDatas = ref({});
	
	onMounted(() => {
		repwdDatas.value = JSON.parse(localStorage.getItem('repwdData'));
	})
	
</script>

<style lang="scss">
	.code{
		overflow: hidden;
		.el-form-item{
			width: 66%;
			float: left;
			.el-input{width: 100%; margin-right: 20px;}
		}
	}
	.user-repwd{
		.repwd-select{ 
			width: 880px; 
			margin:30px auto 0; 
			overflow:hidden;
			li{ 
				border:1px solid #ddd; 
				background-color: #fff;
				margin-bottom: 20px;
				position:relative; 
				padding:15px 160px 20px 100px; 
				min-height:50px; 
				overflow:hidden;
				.btn{ height: 32px; line-height: 32px; padding: 0 20px; color:#fff;background:#015BFE; position:absolute; right:20px; top:26px;}
				i{ display:block; width:60px; height:60px; position:absolute; left:20px; top:12px; }
				.email{background:url("../../assets/images/find_email.png") no-repeat; background-size:contain}
				.mobile{background:url("../../assets/images/find_mobile.png") no-repeat; background-size:contain}
				.pro{background:url("../../assets/images/find_pro.png") no-repeat; background-size:contain}
				h4{ font-size:15px; font-weight:bold; line-height:30px;}
				p{ color:#666;}
			}
		}
	}
</style>